export class ConnectionStartMonitor {
    static readonly type = '[Connection] Start connection monitor';
}

export class ConnectionClearState {
    static readonly type = '[Connection] Clear persisted state';
}
